import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useUser } from '~/api/user';
import { Button, Infotip } from '~/components';
import { clsx } from '~/styles/utils';

import { ConfirmExtraIntegrationDialog } from '../Peppol/ConfirmExtraIntegrationDialog';
import { useConfirmExtraIntegration } from '../Peppol/ConfirmExtraIntegrationDialog.hooks';
import { PeppolForwardingWarning } from '../Peppol/PeppolForwardingWarning';
import { footerStyle, headerCellStyle, headerRowStyle, rowStyle, stackStyle, tableStyle } from './AutoForwarding.css';
import { AutoForwardingForm } from './AutoForwardingForm';

export const AutoForwarding = () => {
  const { data: user } = useUser();
  const { t } = useTranslation(['common', 'settings']);

  const confirmExtraIntegration = useConfirmExtraIntegration();

  const [enabledForm, setEnabledForm] = useState<number | 'create' | null>(
    user.invoiceForwardingSettings.length === 0 && user.peppol.id === null ? 'create' : null,
  );

  const openCreateForm = () => setEnabledForm('create');

  return (
    <div className={stackStyle}>
      {user.invoiceForwardingSettings.length > 0 && (
        <PeppolForwardingWarning description={t('settings:integrations.forwarding.peppol.description')} />
      )}

      <div className={tableStyle}>
        <div className={clsx(rowStyle, headerRowStyle)}>
          <span className={headerCellStyle}>{t('settings:fields.email.label')}</span>

          <span className={headerCellStyle}>
            {t('settings:fields.forwarding.frequency.label')}
            <Infotip>{t('settings:fields.forwarding.frequency.tooltip')}</Infotip>
          </span>

          <span />
        </div>

        {user.invoiceForwardingSettings.map((entry) => (
          <AutoForwardingForm
            disableForm={() => setEnabledForm(null)}
            enableForm={(id) => setEnabledForm(id)}
            invoiceForwardingSettings={entry}
            isEnabled={enabledForm === entry.id}
            isLocked={enabledForm !== null && enabledForm !== entry.id}
            key={entry.id}
          />
        ))}

        {enabledForm === 'create' ? (
          <AutoForwardingForm disableForm={() => setEnabledForm(null)} enableForm={(id) => setEnabledForm(id)} isEnabled isLocked={false} />
        ) : (
          <div className={footerStyle}>
            <Button
              disabled={enabledForm !== null}
              emphasis="primary"
              icon="Add"
              onClick={() =>
                user.invoiceForwardingSettings.length === 0 ? confirmExtraIntegration.confirm(openCreateForm) : openCreateForm()
              }
            >
              {t('settings:integrations.forwarding.add')}
            </Button>
          </div>
        )}
      </div>

      <ConfirmExtraIntegrationDialog handle={confirmExtraIntegration.handle} />
    </div>
  );
};
